// removed by extract-text-webpack-plugin
module.exports = {"halfHero":"src-components-HalfHero----half-hero-module---halfHero---3V2Xa src-styles----index---block---e6f4X","image":"src-components-HalfHero----half-hero-module---image---66Fv0 src-styles----utils---shadowLvl2---3dEn7","content":"src-components-HalfHero----half-hero-module---content---3uEX6","contentWrapper":"src-components-HalfHero----half-hero-module---contentWrapper---2ZUkp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HalfHero/half-hero.module.scss
// module id = 343
// module chunks = 168707334958949